var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 11.4875L2.5626 18.925C2.3501 19.1375 2.10218 19.2438 1.81885 19.2438C1.53551 19.2438 1.2876 19.1375 1.0751 18.925C0.862598 18.7125 0.756348 18.4646 0.756348 18.1813C0.756348 17.8979 0.862598 17.65 1.0751 17.4375L8.5126 10L1.0751 2.56251C0.862598 2.35001 0.756348 2.10209 0.756348 1.81876C0.756348 1.53542 0.862598 1.28751 1.0751 1.07501C1.2876 0.862506 1.53551 0.756256 1.81885 0.756256C2.10218 0.756256 2.3501 0.862506 2.5626 1.07501L10.0001 8.51251L17.4376 1.07501C17.6501 0.862506 17.898 0.756256 18.1813 0.756256C18.4647 0.756256 18.7126 0.862506 18.9251 1.07501C19.1376 1.28751 19.2438 1.53542 19.2438 1.81876C19.2438 2.10209 19.1376 2.35001 18.9251 2.56251L11.4876 10L18.9251 17.4375C19.1376 17.65 19.2438 17.8979 19.2438 18.1813C19.2438 18.4646 19.1376 18.7125 18.9251 18.925C18.7126 19.1375 18.4647 19.2438 18.1813 19.2438C17.898 19.2438 17.6501 19.1375 17.4376 18.925L10.0001 11.4875Z",
    fill: "#292D31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDark);
export default __webpack_public_path__ + "static/media/close_dark.fb09882c3c2794a862911c37e126c763.svg";
export { ForwardRef as ReactComponent };